// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2FS0q","detailsBorder":"styles_detailsBorder__2HcLz"};